const ENDPOINT_CENTER_EWALLET =
  '/secure/e-wallet/center/:centerId/:paymentMethodId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchCenterEwallet({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_CENTER_EWALLET.replace(':centerId', payload.centerId).replace(
          ':paymentMethodId',
          payload.paymentMethodId
        )
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
